import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import ProgressiveImage from '../../../../../../components/global/ProgressiveImage';
import NativeActivityIndicator from '../../../../../../components/global/NativeActivityIndicator';

const propTypes = {
  className: PropTypes.string,
  cardSideGroup: PropTypes.shape({
    id: PropTypes.string.isRequired,
    asset_image: PropTypes.shape({
      id: PropTypes.string.isRequired,
      url: PropTypes.string.isRequired,
    }).isRequired,
    name: PropTypes.string,
  }).isRequired,
  underlayCardSide: PropTypes.shape({
    asset_image: PropTypes.shape({
      id: PropTypes.string.isRequired,
      url: PropTypes.string.isRequired,
    }),
  }),
  onClick: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  displayName: PropTypes.bool,
};

const CardSideGroupPreview = ({
  className,
  cardSideGroup,
  onClick,
  loading,
  displayName = false,
  underlayCardSide,
}) => {
  const underlayCardSideImageUrl = underlayCardSide?.asset_image?.url;

  const classes = classNames({
    'card-side-group-preview': true,
    'has-underlay': !!underlayCardSideImageUrl,
    'is-loading': loading,
    [className]: !!className,
  });

  return (
    <a
      href="#"
      onClick={event => {
        event.preventDefault();
        onClick(cardSideGroup);
      }}
      className={classes}
    >
      <ProgressiveImage src={cardSideGroup.asset_image?.url} alt="" />

      {underlayCardSideImageUrl && (
        <ProgressiveImage
          src={underlayCardSideImageUrl}
          alt=""
          className="card-side-group-preview-underlay-image"
        />
      )}

      {loading && <NativeActivityIndicator size="sm" />}

      {displayName && (
        <p className="card-side-group-preview-title">{cardSideGroup.name}</p>
      )}
    </a>
  );
};

CardSideGroupPreview.propTypes = propTypes;

export default CardSideGroupPreview;
